<app-loader [isLoading]="isLoading"></app-loader>

<div class="containerManageDialogue d-flex flex-column">
  <div class="topHead d-flex justify-content-between">
    <span>Review Merge FC data {{ data.memData.memKey }}</span>
    <div class="close-button" mat-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>

  <div class="content-div">
    <div class="first-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Member Details</span>
      </div>
      <div class="info-details d-flex">
          <div class="details d-flex justify-content-between">
          <span class="details-head">Family Code</span>
          <span class="details-data" style="color:var(--brand-primary)" (click)="onFcClick(data.memData.familyCode)">{{ data.memData.familyCode }}</span>
        </div>
          <div class="details d-flex justify-content-between">
          <span class="details-head">Philantropy Name</span>
          <span class="details-data">{{ data.memData.philanthropyName }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Serial No.</span>
          <span #tooltip="matTooltip" matTooltipPosition="below"
          matTooltip="Sl no. copied" [cdkCopyToClipboard]="data.memData.memkey" class="sl-data">{{ data.memData.memkey }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Full Name</span>
          <span class="details-data">{{ data.memData.fullName }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Guardian's Name</span>
          <span class="details-data">{{ data.memData.guardianName }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Ritwik's Name</span>
          <span class="details-data">{{ data.memData.ritwikName }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Address</span>
          <span class="details-data">{{ data.memData.address }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Contact</span>
          <span class="details-data">{{ data.memData.contact || '-'}}</span>
        </div>
      </div>
    </div>
    <div class="first-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Merge FC Details</span>
      </div>
      <div class="fc-details">
        @for(item of data.fc;track item){
        <div class="info-details d-flex">
          <div class="details d-flex justify-content-between">
            <span class="details-head">Family Code - {{ $index + 1 }}</span>
            <span class="details-data cursor-pointer" style="color:var(--brand-primary)"
              (click)="onFcClick(item.familyCode)">{{
              item.familyCode }}</span>
          </div>
          <div class="details d-flex justify-content-between">
            <span class="details-head">Name</span>
            <span class="details-data">{{ item.phlName }} </span>
          </div>
          <div class="details d-flex justify-content-between">
            <span class="details-head">Comments</span>
            <span class="details-data">{{ item.comments || "-" }}</span>
          </div>
          <span class="separator-div"></span>
        </div>
        }
      </div>
    </div>
  </div>
  <div class="actionButton d-flex pt-2">
    <div (click)="rejectionDatum()" class="reject actBtn d-flex justify-content-center cursor-pointer">
      <div class="cross"></div>
      <span>Reject</span>
    </div>
    <div class="accept actBtn d-flex justify-content-center cursor-pointer" (click)="acceptDialogue()">
      <div class="tick"></div>
      <span>Approve Fully/Partially</span>
    </div>
  </div>
</div>